/* Der Schwarze Kapitän – Scrollytelling: parallax, pinned stages, reveals.
   One rAF loop; all layout reads happen before any style writes. Only transform/opacity/custom properties are animated. */
(function (global) {
  'use strict';
  var doc = global.document;
  var mq = global.matchMedia ? global.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var eintraege = [];   // { el, fn }
  var parallax = [];    // { el, faktor, bezug }
  var buehnen = [];     // { el, schritte }
  var io = null, geplant = false, vh = global.innerHeight;

  function reduziert() { return mq.matches || doc.documentElement.classList.contains('ruhig'); }

  function scan(root) {
    root = root || doc;
    eintraege = eintraege.filter(function (e) { return doc.contains(e.el); });
    parallax = [];
    buehnen = [];
    root.querySelectorAll('[data-parallax]').forEach(function (el) {
      parallax.push({ el: el, faktor: parseFloat(el.getAttribute('data-parallax')) || 0, bezug: el.closest('[data-szene]') || el.parentElement });
    });
    root.querySelectorAll('[data-buehne]').forEach(function (el) {
      buehnen.push({ el: el, schritte: el.querySelectorAll('[data-schritt]').length || 1, letzter: -1 });
    });
    if (!io && 'IntersectionObserver' in global) {
      io = new IntersectionObserver(function (list) {
        list.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('sichtbar'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    root.querySelectorAll('.auftauchen:not(.sichtbar)').forEach(function (el) {
      if (io && !reduziert()) io.observe(el); else el.classList.add('sichtbar');
    });
    planen();
  }

  function registriere(el, fn) { eintraege.push({ el: el, fn: fn }); planen(); }

  function planen() { if (!geplant) { geplant = true; global.requestAnimationFrame(rahmen); } }

  function rahmen() {
    geplant = false;
    var ruhig = reduziert();
    // read phase
    var p = parallax.map(function (x) { return x.bezug.getBoundingClientRect(); });
    var b = buehnen.map(function (x) { return x.el.getBoundingClientRect(); });
    var e = eintraege.map(function (x) { return x.el.getBoundingClientRect(); });
    // write phase
    parallax.forEach(function (x, i) {
      var r = p[i];
      if (r.bottom < -200 || r.top > vh + 200) return;
      var mitte = (r.top + r.height / 2 - vh / 2);
      x.el.style.transform = ruhig ? '' : 'translate3d(0,' + (-mitte * x.faktor).toFixed(1) + 'px,0)';
    });
    buehnen.forEach(function (x, i) {
      var r = b[i];
      var lauf = Math.max(1, r.height - vh);
      var prog = Math.min(1, Math.max(0, -r.top / lauf));
      var schritt = Math.max(0, Math.min(x.schritte - 1, Math.round(-r.top / vh)));
      x.el.style.setProperty('--p', prog.toFixed(4));
      x.el.style.setProperty('--sp', Math.min(1, Math.max(0, -r.top / vh - schritt + 0.5)).toFixed(4));
      if (schritt !== x.letzter) {
        x.letzter = schritt;
        x.el.setAttribute('data-aktiv', schritt);
        x.el.querySelectorAll('[data-schritt]').forEach(function (s) { s.classList.toggle('aktiv', +s.getAttribute('data-schritt') === schritt); });
        x.el.querySelectorAll('[data-bild]').forEach(function (s) { s.classList.toggle('aktiv', +s.getAttribute('data-bild') === schritt); });
      }
    });
    eintraege.forEach(function (x, i) {
      var r = e[i];
      var prog = Math.min(1, Math.max(0, (vh - r.top) / (r.height + vh * 0.35)));
      x.fn(ruhig ? 1 : prog, r);
    });
  }

  global.addEventListener('scroll', planen, { passive: true });
  global.addEventListener('resize', function () { vh = global.innerHeight; planen(); });
  if (mq.addEventListener) mq.addEventListener('change', planen);

  global.Szenen = { scan: scan, registriere: registriere, planen: planen, reduziert: reduziert };
})(window);
